import { CSSProperties } from 'react';

interface Props {
  // eslint-disable-next-line react/require-default-props
  style?: CSSProperties;
  // eslint-disable-next-line react/require-default-props
  onClick?: () => void;
}

function CloseIcon({ style, onClick }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      style={style}
      onClick={onClick}
    >
      <path d="M13 3L3 13" stroke="white" />
      <path d="M3 3L13 13" stroke="white" />
    </svg>
  );
}

export default CloseIcon;
